"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSalesforceCampaignsBySearch = exports.createGetSalesforceCampaignsBySearch = exports.getSalesforceCampaignsListById = exports.creteGetSalesforceCampaignsListById = exports.getSalesforceCampaignsById = exports.createGetSalesforceCampaignsById = exports.getAllSalesforceCampaigns = exports.createGetAllSalesforceCampaigns = void 0;

var _immutable = require("immutable");

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var _hubspot = _interopRequireDefault(require("hubspot.PortalIdParser"));

var _formatSalesforceCampaigns = _interopRequireDefault(require("reference-resolvers/formatters/formatSalesforceCampaigns"));

var _formatSalesforceCampaignsList = _interopRequireDefault(require("reference-resolvers/formatters/formatSalesforceCampaignsList"));

var BATCH_URL = 'sfdc/v1/campaigns/batch';

var campaignSearchFilter = function campaignSearchFilter(search) {
  return function (campaigns) {
    if (!search) {
      return campaigns;
    }

    return campaigns.filter(function (campaign) {
      return campaign.name.toUpperCase().indexOf(search.toUpperCase()) > -1;
    });
  };
};

var createGetAllSalesforceCampaigns = function createGetAllSalesforceCampaigns(_ref) {
  var httpClient = _ref.httpClient;
  return function () {
    return httpClient.get("sfdc/v1/campaigns/" + _hubspot.default.get() + "?detailView=false").then(_formatSalesforceCampaigns.default);
  };
};

exports.createGetAllSalesforceCampaigns = createGetAllSalesforceCampaigns;
var getAllSalesforceCampaigns = createGetAllSalesforceCampaigns({
  httpClient: _apiClient.default
});
exports.getAllSalesforceCampaigns = getAllSalesforceCampaigns;

var createGetSalesforceCampaignsById = function createGetSalesforceCampaignsById(_ref2) {
  var httpClient = _ref2.httpClient;
  return function (ids) {
    return httpClient.post(BATCH_URL, {
      data: ids
    }).then(_formatSalesforceCampaigns.default);
  };
};

exports.createGetSalesforceCampaignsById = createGetSalesforceCampaignsById;
var getSalesforceCampaignsById = createGetSalesforceCampaignsById({
  httpClient: _apiClient.default
});
exports.getSalesforceCampaignsById = getSalesforceCampaignsById;

var creteGetSalesforceCampaignsListById = function creteGetSalesforceCampaignsListById(_ref3) {
  var httpClient = _ref3.httpClient;
  return function (idStrings) {
    return httpClient.post(BATCH_URL, {
      data: idStrings.join(';').split(';')
    }).then((0, _formatSalesforceCampaignsList.default)(idStrings));
  };
};

exports.creteGetSalesforceCampaignsListById = creteGetSalesforceCampaignsListById;
var getSalesforceCampaignsListById = creteGetSalesforceCampaignsListById({
  httpClient: _apiClient.default
});
exports.getSalesforceCampaignsListById = getSalesforceCampaignsListById;

var createGetSalesforceCampaignsBySearch = function createGetSalesforceCampaignsBySearch(options) {
  return function (props) {
    var _props$toJS = props.toJS(),
        query = _props$toJS.query;

    var getFn = createGetAllSalesforceCampaigns(options);
    return getFn().then(campaignSearchFilter(query)).then(function (campaigns) {
      return (0, _immutable.Map)({
        hasMore: false,
        offset: 0,
        count: campaigns.size,
        total: campaigns.size,
        results: campaigns.toList()
      });
    });
  };
};

exports.createGetSalesforceCampaignsBySearch = createGetSalesforceCampaignsBySearch;
var getSalesforceCampaignsBySearch = createGetSalesforceCampaignsBySearch({
  httpClient: _apiClient.default
});
exports.getSalesforceCampaignsBySearch = getSalesforceCampaignsBySearch;